// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../../App.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.work-item {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  gap: 25px;
  padding: 25px;
  box-sizing: border-box;
  border: 3px solid var(--green);
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.2);
  position: relative;

  &.opened {
    box-shadow: 0 0 4px 5px rgba(98, 243, 105, 0.5);
  }
}

.work-item .extra-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  gap: 35px;
  animation: moveDown 0.5s ease-in-out;
}
.work-item ul {
  width: 100%;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  padding-left: 20%;
}

.work-item ul li {
  width: 80%;
  text-align: left;
  text-wrap: wrap;
  font-weight: 500;
  font-size: 1rem;
  line-height: 1.5rem;
  color: var(--white-green);
}

.work-item .full-time {
  position: absolute;
  right: 10px;
  top: 10px;
  padding: 6px;
  border-radius: 8px;
  background-color: var(--dark-green);
  font-size: 0.85em;
  font-family: var(--font-family);
  color: white;
  opacity: 0.7;
}

@keyframes moveDown {
  from {
    transform: translateY(-30px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

@media (max-width: 700px) {
  .work-item {
    gap: 25px;
    padding: 10px;
  }

  .work-item .extra-info {
    gap: 30px;
  }
  .work-item ul {
    width: 90%;
    padding-left: 0%;
  }

  .work-item ul li {
    width: 100%;
    text-align: center;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/WorkExperience/WorkItem.css"],"names":[],"mappings":"AACA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,uBAAuB;EACvB,WAAW;EACX,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;;EAElB;IACE,+CAA+C;EACjD;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,SAAS;EACT,oCAAoC;AACtC;AACA;EACE,WAAW;EACX,UAAU;EACV,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,YAAY;EACZ,kBAAkB;EAClB,mCAAmC;EACnC,iBAAiB;EACjB,+BAA+B;EAC/B,YAAY;EACZ,YAAY;AACd;;AAEA;EACE;IACE,4BAA4B;IAC5B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE;IACE,SAAS;IACT,aAAa;EACf;;EAEA;IACE,SAAS;EACX;EACA;IACE,UAAU;IACV,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;AACF","sourcesContent":["@import url(\"/src/App.css\");\n.work-item {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: flex-start;\n  width: 100%;\n  gap: 25px;\n  padding: 25px;\n  box-sizing: border-box;\n  border: 3px solid var(--green);\n  border-radius: 10px;\n  background: rgba(0, 0, 0, 0.2);\n  position: relative;\n\n  &.opened {\n    box-shadow: 0 0 4px 5px rgba(98, 243, 105, 0.5);\n  }\n}\n\n.work-item .extra-info {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n  gap: 35px;\n  animation: moveDown 0.5s ease-in-out;\n}\n.work-item ul {\n  width: 100%;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 10px;\n  padding-left: 20%;\n}\n\n.work-item ul li {\n  width: 80%;\n  text-align: left;\n  text-wrap: wrap;\n  font-weight: 500;\n  font-size: 1rem;\n  line-height: 1.5rem;\n  color: var(--white-green);\n}\n\n.work-item .full-time {\n  position: absolute;\n  right: 10px;\n  top: 10px;\n  padding: 6px;\n  border-radius: 8px;\n  background-color: var(--dark-green);\n  font-size: 0.85em;\n  font-family: var(--font-family);\n  color: white;\n  opacity: 0.7;\n}\n\n@keyframes moveDown {\n  from {\n    transform: translateY(-30px);\n    opacity: 0;\n  }\n  to {\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n\n@media (max-width: 700px) {\n  .work-item {\n    gap: 25px;\n    padding: 10px;\n  }\n\n  .work-item .extra-info {\n    gap: 30px;\n  }\n  .work-item ul {\n    width: 90%;\n    padding-left: 0%;\n  }\n\n  .work-item ul li {\n    width: 100%;\n    text-align: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
